@if (showButton$ | async) {
    <!-- Desktop version -->
    @if (!isMobile) {
        <div
            class="border-round p-3 relative cursor-pointer"
            style="background-color: var(--quick-start-bg);"
            (click)="openGuide($event)"
            #desktopButtonRef
        >
        <div class="flex justify-content-between gap-2 mb-2">
            <span class="font-bold text-base text-white">
                {{ guideTitle$ | async }}
            </span>
            @if (completedSteps >= maxSteps) {
                <i
                    class="pi pi-times text-white cursor-pointer"
                    (click)="dismissGuide($event)"
                    title="Dismiss">
                </i>
            } @else {
                <i class="pi pi-window-maximize text-white cursor-pointer"></i>
            }
        </div>

        <div
            class="flex align-items-center w-full gap-1"
            role="progressbar"
            [attr.aria-valuenow]="completedSteps"
            [attr.aria-valuemin]="0"
            [attr.aria-valuemax]="maxSteps">
            @for (step of stepsArray; track step) {
                <div
                    class="flex-1 border-round"
                    [style.height.px]="4"
                    [style.background]="completedSteps >= step ? 'var(--check-icon-text-color)' : 'var(--surface-0)'">
                </div>
            }
        </div>
        </div>
    }

    <!-- Mobile version -->
    @if (isMobile) {
        <div
            class="flex align-items-center justify-content-between px-3 py-3 cursor-pointer border-round-3xl ml-2"
            style="background-color: var(--quick-start-bg);"
            #mobileButtonRef
            (click)="openGuide($event)"
        >
            <span class="text-white font-bold text-sm">
                {{ guideTitle$ | async }}
            </span>
            <i class="pi pi-window-maximize text-white ml-2"></i>
        </div>
    }

    @if (steps$ | async; as steps) {
        <app-onboarding-guide
            #onboardingGuide
            [steps]="steps"
            [asapFormId]="currentAsapFormId"
            (stepsChange)="onStepsChange($event)">
        </app-onboarding-guide>
    }
}
